import { render, staticRenderFns } from "./MainWrapper.vue?vue&type=template&id=62e47b48&scoped=true&"
import script from "./MainWrapper.vue?vue&type=script&lang=js&"
export * from "./MainWrapper.vue?vue&type=script&lang=js&"
import style0 from "./MainWrapper.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MainWrapper.vue?vue&type=style&index=1&id=62e47b48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e47b48",
  null
  
)

component.options.__file = "MainWrapper.vue"
export default component.exports